import { render, staticRenderFns } from "./password-forgot.vue?vue&type=template&id=8d2239c8&lang=html&"
import script from "./password-forgot.vue?vue&type=script&lang=js&"
export * from "./password-forgot.vue?vue&type=script&lang=js&"
import style0 from "./password-forgot.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports